import type { FaqType, StudentType } from './types';

export const initialStatePageKey = 'PanelData';
export const USER_DASHBOARD_AMPLITUDE_PAGE_NAME = 'User Dashboard';
export const USER_DASHBOARD_PAGE_KEY = 'user-panel';

export const PLAYER_URL_SOURCES = {
  TRACK_CARD: 'Track Card',
  BUNDLE_CARD: 'Bundle Card',
  CAREER_CARD: 'Career Card',
  DEGREE_DETAIL: 'MicroDegree Detail',
} as const;

export const ENROLLMENT_URL_SOURCES = {
  RECOMMENDED_COURSES: 'Recommended Courses',
} as const;

export const FAQS_BY_STUDENT_TYPE: Record<StudentType, FaqType[]> = {
  b2b: [
    {
      key: 'upload-projects',
      href: 'https://ayuda.crehana.com/s/article/Subir-proyecto-final',
      text: 'UD_UPLOAD_PROJECTS',
    },
    {
      key: 'how-to-start-my-courses',
      href: 'https://ayuda.crehana.com/s/article/C%C3%B3mo-empiezo-mis-cursos',
      text: 'UD_START_COURSES',
    },
  ],
  premium: [
    {
      key: 'how-to-contact-with-mentors',
      href: 'https://crehana.force.com/ayuda/s/article/C%C3%B3mo-aprovechar-la-mentor%C3%ADa-personalizada',
      text: 'UD_CHAT_WITH_MENTORS',
    },
    {
      key: 'how-to-upload-my-project-premium',
      href: 'https://crehana.force.com/ayuda/s/article/C%C3%B3mo-subo-mi-proyecto',
      text: 'UD_UPLOAD_PROJECT',
    },
  ],
  'premium-trial': [
    {
      key: 'how-to-contact-with-mentors-pt',
      href: 'https://crehana.force.com/ayuda/s/article/C%C3%B3mo-aprovechar-la-mentor%C3%ADa-personalizada',
      text: 'UD_CHAT_WITH_MENTORS',
    },
    {
      key: 'how-to-upload-my-project-premium-pt',
      href: 'https://crehana.force.com/ayuda/s/article/C%C3%B3mo-subo-mi-proyecto',
      text: 'UD_UPLOAD_PROJECT',
    },
  ],
  register: [
    {
      key: 'how-to-contact-with-mentors-rg',
      href: 'https://crehana.force.com/ayuda/s/article/C%C3%B3mo-aprovechar-la-mentor%C3%ADa-personalizada',
      text: 'UD_CHAT_WITH_MENTORS',
    },
    {
      key: 'how-to-upload-my-project-premium-rg',
      href: 'https://crehana.force.com/ayuda/s/article/C%C3%B3mo-subo-mi-proyecto',
      text: 'UD_UPLOAD_PROJECT',
    },
  ],
  payg: [
    {
      key: 'can-not-find-courses',
      href: 'https://ayuda.crehana.com/s/article/No-encuentro-mis-cursos-motivos',
      text: 'UD_CANT_FIND_COURSES',
    },
    {
      key: 'how-to-upload-my-project-b2b',
      href: 'https://ayuda.crehana.com/s/article/Subir-proyecto-final',
      text: 'UD_UPLOAD_PROJECT',
    },
  ],
  degree: [
    {
      key: 'how-to-upload-my-project-md',
      href: 'https://ayuda.crehana.com/s/article/C%C3%B3mo-puedo-subir-mi-proyecto',
      text: 'UD_UPLOAD_PROJECTS_TO_PLATFORM',
    },
    {
      key: 'where-is-the-project-description',
      href: 'https://ayuda.crehana.com/s/article/D%C3%B3nde-encuentro-la-descripci%C3%B3n-de-mi-proyecto',
      text: 'UD_PROJECT_DESCRIPTION',
    },
  ],
};

export const FAQ_LINKS = {
  FAQ_COURSE:
    'https://ayuda.crehana.com/hc/es/articles/360014087874-No-encuentro-mis-cursos-motivos-',
  FAQ_DIPLOMA:
    'https://ayuda.crehana.com/hc/es/articles/115004212205--C%C3%B3mo-subo-mi-proyecto-final-para-obtener-mi-diploma-',
  FAQ_PROJECT_UPLOAD:
    'https://ayuda.crehana.com/hc/es/articles/1500007531682-Subir-proyecto-final-',
  FAQ_START_COURSES:
    'https://ayuda.crehana.com/hc/es/articles/1500007529102--C%C3%B3mo-empiezo-mis-cursos-',
  FAQ_GENERAL: 'https://ayuda.crehana.com/',
};
